import { gql } from "@apollo/client";

export const CREATE_SCHEDULE_BOOKING = gql`
  mutation CreateScheduleBooking($input: CreateScheduleBookingInput!) {
    createScheduleBooking(input: $input) {
      id
      name
      email
      phoneNo
      date
      time
      status
      notes
      createdAt
    }
  }
`;

export const GET_SCHEDULE_BOOKINGS = gql`
  query GetScheduleBookings($status: ScheduleBookingStatus) {
    scheduleBookings(status: $status) {
      id
      name
      email
      phoneNo
      date
      time
      status
      notes
      createdAt
      updatedAt
    }
  }
`;

export const GET_SCHEDULE_BOOKING = gql`
  query GetScheduleBooking($id: ID!) {
    scheduleBooking(id: $id) {
      id
      name
      email
      phoneNo
      date
      time
      status
      notes
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_SCHEDULE_BOOKING = gql`
  mutation UpdateScheduleBooking($id: ID!, $input: UpdateScheduleBookingInput!) {
    updateScheduleBooking(id: $id, input: $input) {
      id
      name
      email
      phoneNo
      date
      time
      status
      notes
      updatedAt
    }
  }
`;

export const DELETE_SCHEDULE_BOOKING = gql`
  mutation DeleteScheduleBooking($id: ID!) {
    deleteScheduleBooking(id: $id)
  }
`;

